var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPremium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diamond 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 8H35.25L39.75 17L22.875 37.25L6 17L10.5 8Z",
    stroke: "url(#paint0_linear_11055_66446)",
    strokeWidth: 3.65625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9727 17.0039H28.7852",
    stroke: "url(#paint1_linear_11055_66446)",
    strokeWidth: 3.65625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11055_66446",
    x1: 39.75,
    y1: 15.3125,
    x2: 4.77201,
    y2: 18.1443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F8CB38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A205"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11055_66446",
    x1: 28.7852,
    y1: 17.2539,
    x2: 21.4804,
    y2: 23.3081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F8CB38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A205"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/Premium.6bb8c99d.svg";
export { ForwardRef as ReactComponent };